import React from 'react';

// Create a new context
const FilterContext = React.createContext();

export default FilterContext;
